import { FETCH_BROWSE, RESET, SELECT_TAB, FETCH_NEXT, SET_FETCHING } from './BrowseActions';
import { reduceBrowseResults, getUniqueItemsById, getFilterDisplayName } from './BrowseProcessor';

const INITIAL_STATE = {
  browsePanel: null,
  browseFilters: [],
  browseResults: {},
  error: false,
  fetching: false,
  selectedTab: null,
};

export default function(state = INITIAL_STATE, action) {
  const data = action?.payload?.data ?? null;
  switch (action.type) {
    case FETCH_BROWSE: {
      if (!data) return state;
      const browsePanel = data?.panels ?? {};
      const filters = browsePanel?.member ?? [];
      const browseResults = reduceBrowseResults({ filters });
      const browseFilters = Object.keys(browseResults).map(getFilterDisplayName);
      return {
        ...state,
        browsePanel,
        browseFilters,
        browseResults,
      };
    }
    case FETCH_NEXT: {
      const browseResults = state?.browseResults ?? {};
      const selectedTab = data?.filterName ?? '';
      const currentFilter = browseResults?.[selectedTab] ?? [];
      const newItems = data?.member ?? [];
      const id = data?.view?.['@id'] ?? null;
      let newNext = data?.view?.next ?? null;
      if (newNext === id) newNext = null;
      const results = getUniqueItemsById([...(currentFilter?.items ?? []), ...newItems]);
      return {
        ...state,
        browseResults: {
          ...browseResults,
          [selectedTab]: {
            ...browseResults?.[selectedTab],
            items: results,
            next: newNext,
          },
        },
        fetching: false,
      };
    }

    case SET_FETCHING: {
      const value = action?.payload;
      return {
        ...state,
        fetching: value,
      };
    }
    case RESET: {
      return INITIAL_STATE;
    }
    case SELECT_TAB: {
      return {
        ...state,
        selectedTab: action?.payload,
      };
    }

    default: {
      return state;
    }
  }
}
